<template>
  <f7-page>
    <template #fixed>
      <TheNavbar
        nav-title="Actividad de trabajadores"
        back-btn-enable
      />
    </template>

    <f7-block class="main-workers-activity block no-margin padding bg-darkgray">
      <UCSearchEntityERP
        class="main-workers-activity__search"
        :title="$t('searchEntity.productionActivity.title.productionActivitySearch')"
        :placeholder="$t('searchEntity.productionActivity.placeholder.productionActivityCode')"
        :search-text="$t('searchEntity.productionActivity.searchText')"
        :search-cancellation-text="$t('searchEntity.productionActivity.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.productionActivity.searchNotFoundText')"
        :end-point-for-code-search="ActivityCodeSearch"
        :end-point-for-list="ActivityList"
        :property-entity-shown-input="['Codigo', 'Nombre']"
        :property-entity-shown-list-title="['Codigo']"
        :property-entity-shown-list-subtitle="['Nombre']"
        @selection="EventSelectedActivityProduction"
      />
      <!-- Mostrar solo excedidos -->
      <f7-block
        v-show="showExceededOnlySelector"
        class="content-titulo-select"
      >
        <label
          class="checkbox"
          @change="ChangeShowExceededOnly"
        >
          <input
            :checked="showExceededOnly"
            type="checkbox"
          >
          <i class="icon-checkbox" />
          Mostrar sólo excedidos
        </label>
      </f7-block>
    </f7-block>
    <f7-block class="content-workers-list no-padding no-margin">
      <UCPreload :show="showPreload" />
      <div
        v-for="r in listWorkersTime"
        :key="r.Id"
        @click="ShowDetailWorker(r.Trabajador)"
      >
        <f7-list
          v-if="r.TotalTiempo > 0"
          media-list
        >
          <f7-list-item
            chevron-center
            link="#"
            :title="TextMaximumLength(r.Trabajador.Sujeto.NombreCompleto, 40)"
            :subtitle="GetHoursAndMinutes(r.TotalTiempo)"
          >
            <div
              v-if="r.TotalTiempo > 0"
            >
              <div
                v-if="r.TotalTiempoMaximoPermitido > 0"
                class="item-text"
                :class="{
                  'color-green': (r.TotalTiempo * 100 / r.TotalTiempoMaximoPermitido - 100 < 0),
                  'color-red': (r.TotalTiempo * 100 / r.TotalTiempoMaximoPermitido - 100 > 0),
                }"
              >
                {{ `${r.TotalTiempo * 100 / r.TotalTiempoMaximoPermitido - 100} %` }}
              </div>
            </div>
          </f7-list-item>
        </f7-list>
      </div> <!-- Fin registro -->
    </f7-block>
  </f7-page>
</template>

<script>
// import eventBus from '@/js/event-bus';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import APIErp from '@/js/services/APIErp';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import { HiDateTimeSupport, HiStringSupport } from '@/js/common/HIConversionSupport';
import TheNavbar from '@/components/TheNavbar.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmWorkersActivity',
  components: {
    UCSearchEntityERP,
    UCPreload,
    TheNavbar,
  },

  data() {
    return {
      selectedActivity: null,
      showPreload: false,
      listWorkersTime: [],
      dateOfQuery: null,
      showExceededOnly: false,
      // Check que aparece en actividades con un tiempo máximo definido.
      showExceededOnlySelector: false,
    };
  },

  mounted() {
    this.StartForm();
  },

  methods: {
    StartForm() {
      Log(this, this.StartForm.name);
      this.listWorkersTime = [];
      this.dateOfQuery = new Date();
    },

    EventSelectedActivityProduction(objActivity) {
      Log(this, this.EventSelectedActivityProduction.name);
      this.selectedActivity = objActivity;
      this.GetWorkersTimesActivity();
    },
    ShowDetailWorker(workerSelected) {
      Log(this, this.ShowDetailWorker.name);
      f7.views.main.router.navigate('/presence/workerRecords/workerRecords', {
        props: {
          workerSelectedDefault: workerSelected,
        },
      });
    },
    TextMaximumLength(text, numCharacters) {
      return HiStringSupport.TextMaximumLength(text, numCharacters);
    },
    GetHoursAndMinutes(minutes) {
      return HiDateTimeSupport.GetHoursAndMinutes(minutes);
    },
    GetWorkersTimesActivity() {
      Log(this, this.GetWorkersTimesActivity.name);
      const self = this;
      this.listWorkersTime = [];
      if (this.selectedActivity != null) {
        this.Conections_GetWorkersTimesActivity(
          this.selectedActivity,
          HiDateTimeSupport.FormatDateTime(this.dateOfQuery, ''),
          this.showExceededOnly,
        ).then((data) => {
          self.listWorkersTime = data;
          self.CheckIfActivityDefinesMaximumTime();
        });
      }
    },
    CheckIfActivityDefinesMaximumTime() {
      Log(this, this.CheckIfActivityDefinesMaximumTime.name);
      if (this.listWorkersTime != null
        && this.listWorkersTime.length > 0
        && this.listWorkersTime[0].TotalTiempoMaximoPermitido > 0) {
        this.showExceededOnlySelector = true;
        return true;
      }
      this.showExceededOnlySelector = false;
      return false;
    },
    ChangeShowExceededOnly() {
      Log(this, this.ChangeShowExceededOnly.name);
      this.showExceededOnly = !this.showExceededOnly;
      if (this.selectedActivity != null) {
        this.GetWorkersTimesActivity();
      }
    },

    Conections_GetWorkersTimesActivity(selectedActivity, dateOfQuery, exceededOnly) {
      Log(this, this.Conections_GetWorkersTimesActivity.name);
      const self = this;
      self.showPreload = true;
      return new Promise((resolve, reject) => {
        APIErp.callGetWorkersTimesActivity(selectedActivity.Id, dateOfQuery, exceededOnly)
          .then((result) => {
            self.showPreload = false;
            resolve(result.data);
          }).catch((error) => {
            self.showPreload = false;
            LogError(this, this.Conections_GetWorkersTimesActivity.name, error);
            reject(error);
          });
      });
    },
    ActivityCodeSearch(params) {
      return APIErp.callProductionActivitySearchCode(params);
    },
    ActivityList() {
      // return APIErp.callProductionActivityList();
      return APIErp.callProductionActivityListAuthorized();
    },
  },
};
</script>

<style lang="scss">
.main-workers-activity {
  &.bg-darkgray {
    background-color: var(--his-darkgray);
  }

  .block-title {
    color: #fff;
    padding: 0 10px;
    margin: 0 0 10px;
  }

  &__search {
    --search-title-color: #fff;
  }
}

.main-workers-activity,
.main-new-massive-records {
  .content-workers-list {
    margin-top: 0;

    ul {
      &::before {
        height: 0 !important;
      }

      li {
        .item-content {
          padding-left: 0;

          .item-text {
            font-weight: 500;
          }
        }
      }
    }
  }

  .content-titulo-select {
    .checkbox {
      i {
        margin-right: 10px;
      }
    }
  }
}

.textoRojo {
  color: var(--his-tomate);
}

.textoVerde {
  color: #66ba33;
}
</style>
